import { render } from "./AddUpdateSpaceForm.vue?vue&type=template&id=0953c3e5&scoped=true"
import script from "./AddUpdateSpaceForm.vue?vue&type=script&lang=js"
export * from "./AddUpdateSpaceForm.vue?vue&type=script&lang=js"

import "./AddUpdateSpaceForm.vue?vue&type=style&index=0&id=0953c3e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0953c3e5"]])

export default __exports__